import { useLocation } from '@gatsbyjs/reach-router';
import { useMemo } from 'react';

export const productCategories = [
  {
    id: 'calendars',
    title: 'Календари',
  },
  {
    id: 'photobooks',
    title: 'Фотокниги',
  },
  {
    id: 'notebooks',
    title: 'Блокноты',
  },
  {
    id: 'prints',
    title: 'Фотокарточки',
  },
];

const breadcrumbsPathMainItem = [{ title: 'Главная', url: '/' }];

const getBreadcrumbsPath = (category: string | undefined) => {
  const currCategory = productCategories.find((item) => item.id === category);
  if (!currCategory) return breadcrumbsPathMainItem;

  return [
    ...breadcrumbsPathMainItem,
    { title: currCategory.title, url: `/products/${currCategory.id}` },
  ];
};

export function useProductsBreadcrumbsPath() {
  const location = useLocation();

  return useMemo(() => {
    const currentCategory = location.pathname.split('/').filter(Boolean)[1];
    return { breadcrumbsPath: getBreadcrumbsPath(currentCategory) };
  }, [location.pathname]);
}
